






import Vue from 'vue';
import _ from '../../utils';

export default Vue.extend({
  mounted() {
    const self = this as Vue;
    const appEl = _.component.getAppEl();
    appEl.insertBefore(self.$el, appEl.firstChild);
  },
  destroyed() {
    const self = this as Vue;
    const appEl = _.component.getAppEl();
    // appEl could already be cleared, for example on page change
    if (appEl && appEl.contains(self.$el)) {
      appEl.removeChild(self.$el);
    }
  },
});
